// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tvjs-x-window.sett-win[data-v-ba99fe08]{padding-bottom:30px}.sett-win-item[data-v-ba99fe08]{display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:space-around;align-content:center;align-items:center}.sett-win-item label[data-v-ba99fe08]{min-width:80px}.sett-win-empty[data-v-ba99fe08]{opacity:.5}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
